<template>
  <div class="page-container">
    <div class="query-title">材料计划期初调整</div>

    <div class="content">
      <QueryParams ref="QueryParams" :loading="loading" :search-field="searchField" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="材料计划调整"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="upload" tip="选择文件" @click="handleImportExcel('matAdjustmentDetail')" />
            <table-button name="export" tip="保存" @click="handleSaveImportExcel" />
            <table-button name="download" tip="下载模板" @click="downloadTemplate('matAdjustmentDetail')" />
            <table-button name="delete" tip="删除" @click="handleDelImportExcel" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
              <div :key="item.field">
                <span>{{ row[item.field] }}</span>
              </div>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import {
  apiExportExcelTemplate,
  apiExcelImport,
  apiGetExcelImportData
} from '@/api/common'
import { getToken } from '@/utils/auth'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { apiMaterialChangeImportList, apiMaterialChangeImportDel, apiMaterialChangeImportSaveCheck, apiMaterialChangeImportSave } from '@/api/sap/material-plan'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/dateInitEdit'
import { frontExport, exportAll } from '@/utils/frontExport'
export default {
  mixins: [tableMixins],
  data() {
    return {
      conditions: {
        batchNumber: '',
        templateCode: ''
      },
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 }
        ],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        if (ranges) {
          // 保存 查询组件的查询参数
          this.ranges = ranges
          this.handleRanges(ranges)
        }
        this.isSetFilter = false
      }
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        mv_role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await apiMaterialChangeImportList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.pagination
      const params = { ...this.conditions, page, pagesize }
      const res = await apiGetExcelImportData(params)
      // 转换一哈驼峰
      for (const item of res.data.Rows) {
        // 转换大小写
        Object.keys(item).forEach(key => {
          item[this.toLineAndUp(key)] = item[key]
          if (this.toLineAndUp(key) !== key) {
            delete item[key]
          }
        })
      }

      const result = await apiMaterialChangeImportSaveCheck({
        item: res.data.Rows
      })
      if (result.msgtype === 'S') {
        this.gridOptions.data = result.item
      } else {
        this.$message.error(result.message)
      }
    },
    // 驼峰转成下划线
    toLineAndUp(str = '') {
      return str.replace(/([A-Z])/g, '_$1').toLowerCase()
    },
    // 导入excel
    async handleImportExcel(tem) {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: tem
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.conditions.batchNumber = res.data
            this.conditions.templateCode = tem
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 保存
    async handleSaveImportExcel() {
      if (!this.gridOptions.data.length) return this.$message.warning('没有可以保存的数据！')
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        item: this.gridOptions.data
      }
      const res = await apiMaterialChangeImportSave(params)
      if (res.msgtype === 'S') {
        this.$message.success(res.message)
        this.gridOptions.data = []
      } else {
        this.$message.error(res.message)
      }
    },
    // 模板下崽
    async downloadTemplate(tem) {
      const res = await apiExportExcelTemplate(tem)

      if (res?.status !== 0) {
        return
      }

      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=材料计划期初调整模板`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', '材料计划期初调整模板')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    async handleDelImportExcel() {
      const checkedData = this.$refs.xTable.getCheckboxRecords()
      if (!checkedData?.length) return this.$message.warning('请选择要删除的数据！')
      const ids = checkedData.map(v => v._X_ID)
      const res = await apiMaterialChangeImportDel({
        select: checkedData
      })
      if (res.msgtype === 'S') {
        // this.queryData(1)
        this.gridOptions.data = this.gridOptions.data.filter(item => {
          return !ids.includes(item._X_ID)
        })
      } else {
        this.$message.error(res.message)
      }
    },
    // // 导出全部 导出本页
    // async exportExcel(type) {
    //   if (!this.gridOptions.data.length) {
    //     await this.queryData()
    //   }
    //   // 导出本页
    //   if (type === 'page') {
    //     frontExport(this.gridOptions.columns, this.gridOptions.data, '经销商开票情况明细报表')
    //   } else {
    //     // 导出全部
    //     const params = {
    //       ...filterSapParams(this.conditions),
    //       user_bp: this.$store.getters.role.USER_BP,
    //       role: this.$store.getters.role.ROLE,
    //       ...this.pagination
    //     }
    //     const options = {
    //       columns: this.gridOptions.columns,
    //       resk: 'data',
    //       fileName: '经销商开票情况明细报表'
    //     }
    //     exportAll(reportForm1, params, options)
    //   }
    // },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/material-plan-manage/dateInitEdit.vue